import * as React from 'react';

import type { InstrumentType } from '../../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import { JobType } from '../../../../../entities';
import {
  AcousticGuitarIcon,
  BassIcon,
  BrassIcon,
  DrumsIcon,
  ElectricGuitarIcon,
  MultiInstrumentsIcon,
  OrganIcon,
  PianoIcon,
  PitchedPercussionIcon,
  StringsIcon,
  SynthLead,
  VocalsIcon,
} from './InstrumentIcons';

export interface InstrumentConfig {
  type: 'multiple' | InstrumentType;
  label: string;
  component?: React.JSX.Element;
}

export const instrumentsConfig: Partial<Record<InstrumentType | 'multiple', InstrumentConfig>> = {
  piano: {
    type: 'piano',
    label: 'home.input.dialog.choose_instrument.instruments.piano',
    component: <PianoIcon />,
  },
  organ: {
    type: 'organ',
    label: 'home.input.dialog.choose_instrument.instruments.organ',
    component: <OrganIcon />,
  },
  vocals: {
    type: 'vocals',
    label: 'home.input.dialog.choose_instrument.instruments.vocals',
    component: <VocalsIcon />,
  },
  electric_guitar: {
    type: 'electric_guitar',
    label: 'home.input.dialog.choose_instrument.instruments.electric_guitar',
    component: <ElectricGuitarIcon />,
  },
  bass: {
    type: 'bass',
    label: 'home.input.dialog.choose_instrument.instruments.bass',
    component: <BassIcon />,
  },
  acoustic_guitar: {
    type: 'acoustic_guitar',
    label: 'home.input.dialog.choose_instrument.instruments.acoustic_guitar',
    component: <AcousticGuitarIcon />,
  },
  guitar: {
    type: 'guitar',
    label: 'home.input.dialog.choose_instrument.instruments.guitar',
    component: <AcousticGuitarIcon />,
  },
  drums: {
    type: 'drums',
    label: 'home.input.dialog.choose_instrument.instruments.drums',
    component: <DrumsIcon />,
  },
  pitched_percussion: {
    type: 'pitched_percussion',
    label: 'home.input.dialog.choose_instrument.instruments.pitched_percussion',
    component: <PitchedPercussionIcon />,
  },
  strings: {
    type: 'strings',
    label: 'home.input.dialog.choose_instrument.instruments.strings',
    component: <StringsIcon />,
  },
  brass: {
    type: 'brass',
    label: 'home.input.dialog.choose_instrument.instruments.brass',
  },
  reed: {
    type: 'reed',
    label: 'home.input.dialog.choose_instrument.instruments.reed',
  },
  pipe: {
    type: 'pipe',
    label: 'home.input.dialog.choose_instrument.instruments.pipe',
  },
  wind: {
    type: 'wind',
    label: 'home.input.dialog.choose_instrument.instruments.wind',
    component: <BrassIcon />,
  },
  multiple: {
    type: 'multiple',
    label: 'home.input.dialog.choose_instrument.instruments.multiple',
    component: <MultiInstrumentsIcon />,
  },
  chords: {
    type: 'chords',
    label: 'home.input.dialog.choose_instrument.instruments.chords',
    component: null,
  },
  // synth_lead: {
  //   type: 'synth_lead',
  //   label: 'home.input.dialog.choose_instrument.instruments.synth_lead',
  //   component: <SynthLead />,
  // },
  // synth_pad: {
  //   type: 'synth_pad',
  //   label: 'home.input.dialog.choose_instrument.instruments.synth_pad',
  //   component: <SynthPad />,
  // },
  synth: {
    type: 'synth',
    label: 'home.input.dialog.choose_instrument.instruments.synth',
    component: <SynthLead />,
  },
};

export const INSTRUMENTS: Record<JobType, { config: InstrumentConfig[] }> = {
  [JobType.TranscribePiano]: {
    config: [
      instrumentsConfig.piano,
      instrumentsConfig.organ,
      instrumentsConfig.pitched_percussion,
      instrumentsConfig.multiple,
    ],
  },
  [JobType.TranscribeGuitar]: {
    config: [
      instrumentsConfig.acoustic_guitar,
      instrumentsConfig.electric_guitar,
      instrumentsConfig.bass,
      instrumentsConfig.multiple,
    ],
  },
  [JobType.TranscribeSinging]: {
    config: [instrumentsConfig.vocals, instrumentsConfig.multiple],
  },
  [JobType.TranscribeDrums]: {
    config: [instrumentsConfig.drums, instrumentsConfig.multiple],
  },
  [JobType.TranscribeStudio]: {
    config: [
      instrumentsConfig.vocals,
      instrumentsConfig.piano,
      instrumentsConfig.guitar,
      instrumentsConfig.bass,
      instrumentsConfig.strings,
      instrumentsConfig.wind,
      instrumentsConfig.synth,
      instrumentsConfig.drums,
    ],
  },
  [JobType.TranscribeScan]: {
    config: [
      instrumentsConfig.vocals,
      instrumentsConfig.piano,
      instrumentsConfig.acoustic_guitar,
      instrumentsConfig.electric_guitar,
      instrumentsConfig.bass,
      instrumentsConfig.strings,
      instrumentsConfig.wind,
      instrumentsConfig.synth,
      instrumentsConfig.brass,
      instrumentsConfig.reed,
      instrumentsConfig.pipe,
      instrumentsConfig.organ,
      instrumentsConfig.pitched_percussion,
    ],
  },
  [JobType.TranscribeVST]: { config: [] },
  [JobType.TranscribeWind]: {
    config: [instrumentsConfig.wind, instrumentsConfig.multiple],
  },
  [JobType.TranscribeViolin]: {
    config: [instrumentsConfig.strings, instrumentsConfig.multiple],
  },
};
